import React, { useEffect, useState } from "react";
import api from "../../util/panelApi";
import { PageHead, when, img } from "./kit";
import { ROLE_LABEL } from "../../Components/navbar/Sidebar";

const SendPackage = () => {
  const [me, setMe] = useState(null);
  const [sent, setSent] = useState([]);
  const [q, setQ] = useState("");
  const [acc, setAcc] = useState(null);
  const [sel, setSel] = useState("");
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);

  const load = async () => {
    const [a, b] = await Promise.all([api.staffMe(), api.staffSent()]);
    if (a?.status) setMe(a);
    if (b?.status) setSent(b.grants);
  };
  useEffect(() => {
    load();
  }, []);

  const find = async (e) => {
    e?.preventDefault();
    setMsg("");
    const r = await api.staffLookup(q.trim());
    setAcc(r?.status ? r.account : null);
    if (!r?.status) setMsg(r?.message || "Bulunamadı");
  };

  const send = async () => {
    const p = me.packages.find((x) => x._id === sel);
    if (!p || !acc) return;
    if (!window.confirm(`${p.name}, ${acc.name} (ID ${acc.uniqueID}) kişisine gönderilsin mi?`)) return;
    setBusy(true);
    const r = await api.staffSend({ templateId: sel, q: acc.uniqueID });
    setBusy(false);
    setMsg(r?.message || (r?.status ? "Gönderildi" : "Gönderilemedi"));
    if (r?.status) {
      setAcc(null);
      setQ("");
      setSel("");
      load();
    }
  };

  return (
    <>
      <PageHead title="Paket gönder" sub={me ? `${me.me.name} · ${ROLE_LABEL[me.me.role] || ""}${me.me.region ? " · " + me.me.region : ""}` : "Yükleniyor…"} />
      <div className="row">
        {(me?.packages || []).map((p) => {
          const left = p.quota === null ? null : Math.max(0, p.quota - p.used);
          const pct = p.quota ? Math.min(100, (p.used / p.quota) * 100) : 0;
          return (
            <div className="col-md-6 col-xl-4" key={p._id}>
              <div className="card" style={{ borderColor: sel === p._id ? "#F4B73F" : undefined, cursor: left === 0 ? "not-allowed" : "pointer", opacity: left === 0 ? 0.6 : 1 }} onClick={() => left !== 0 && setSel(p._id)}>
                <div className="card-body">
                  <b style={{ fontSize: 15 }}>{p.icon} {p.name}</b>
                  {p.note && <div style={{ fontSize: 12, color: "#64748B" }}>{p.note}</div>}
                  <div style={{ marginTop: 10, fontSize: 13 }}>{p.quota === null ? "Sınırsız (sahip)" : `Bu ay: ${p.used}/${p.quota} · kalan ${left}`}</div>
                  {p.quota !== null && (
                    <div style={{ height: 6, borderRadius: 9, background: "#E2E8F0", marginTop: 6, overflow: "hidden" }}>
                      <div style={{ width: `${pct}%`, height: "100%", background: "#F4B73F" }} />
                    </div>
                  )}
                </div>
              </div>
            </div>
          );
        })}
        {me && !me.packages.length && <div className="badu-empty" style={{ padding: 20 }}>Sana tanımlı paket kotası yok.</div>}
      </div>

      <div className="card">
        <div className="card-body">
          <form className="d-flex" style={{ gap: 8 }} onSubmit={find}>
            <input className="form-control" placeholder="Alıcının ID'si" value={q} onChange={(e) => setQ(e.target.value)} />
            <button className="btn btn-outline-primary" type="submit">Bul</button>
          </form>
          {acc && (
            <div className="d-flex align-items-center justify-content-between" style={{ marginTop: 12, gap: 10, flexWrap: "wrap" }}>
              <div className="d-flex align-items-center" style={{ gap: 10 }}>
                {acc.image && <img className="table_image" src={img(acc.image)} alt="" />}
                <div><b>{acc.name}</b><div style={{ fontSize: 12, color: "#64748B" }}>ID {acc.uniqueID} · {acc.country || ""}</div></div>
              </div>
              <button className="btn btn-primary" disabled={!sel || busy} onClick={send}>{sel ? "Paketi gönder" : "Önce paket seç"}</button>
            </div>
          )}
          {msg && <div style={{ marginTop: 10, fontSize: 13, color: "#64748B" }}>{msg}</div>}
        </div>
      </div>

      <div className="card">
        <div className="card-body table-responsive">
          <h6>Gönderdiklerim</h6>
          <table className="table">
            <thead><tr><th>Tarih</th><th>Paket</th><th>Alan kişi</th></tr></thead>
            <tbody>
              {sent.map((g) => (
                <tr key={g._id}><td>{when(g.createdAt)}</td><td>{g.templateName}</td><td>{g.userName} · ID {g.uniqueID}</td></tr>
              ))}
              {!sent.length && <tr><td colSpan={3}><div className="badu-empty">Henüz gönderim yok.</div></td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default SendPackage;
